import React from "react";
import { QuoteCard } from "../cards/QuoteCard";
import { MessageLayout } from "../layout/MessageLayout";
import { useChatActions } from "../../context/ChatActionContext";
import type { ChatMessageProps } from "../types";
import type { PendingQuoteMessage } from "../../types";

interface QuoteMessageProps extends Omit<ChatMessageProps, "message"> {
  message: PendingQuoteMessage;
  sender: "me" | "other";
  time: string;
}

export const QuoteMessage: React.FC<QuoteMessageProps> = ({
  message,
  messageId,
  role,
  sender,
  partyName,
  time,
  isLatestQuote,
  contractId,
  hasPendingCashDeposit,
  showAvatar = true,
  showName = true,
}) => {
  const { isRead, isPending, isError } = message;
  const { onViewQuote, onQuoteAction, onRetry, onViewContract } =
    useChatActions();

  // ✅ Determine effective contract ID: Use contract ID from room context (prop)
  const effectiveContractId = contractId;

  return (
    <MessageLayout
      sender={sender}
      partyName={partyName}
      time={time}
      isRead={isRead}
      isPending={isPending}
      isError={isError}
      showAvatar={showAvatar}
      showName={showName}
      variant="card"
      onRetry={() => onRetry?.(message.id)}
    >
      <QuoteCard
        message={{
          quoteData: message.quoteData,
          createdAt: message.createdAt,
          isPending: isPending,
        }}
        role={role}
        sender={sender}
        onViewQuote={() => onViewQuote?.(messageId!)}
        onContract={
          effectiveContractId && onViewContract
            ? () => onViewContract(effectiveContractId)
            : role === "buyer"
              ? () => onQuoteAction?.(messageId!)
              : undefined
        }
        onEditQuote={
          role === "supplier" ? () => onQuoteAction?.(messageId!) : undefined
        }
        isLatestQuote={isLatestQuote}
        contractId={effectiveContractId}
        hasPendingCashDeposit={hasPendingCashDeposit}
      />
    </MessageLayout>
  );
};
